<template>
    <div id="app" class="flex items-center justify-center text-center flex-col container mx-auto">
        <h1 class="text-2xl">Fun Nonogram solver</h1>
        <Nonogram :rows="rows" :cols="cols"/>
        <div class="w-2/3 text-sm text-left mt-4 mx-1">
            <div><strong>Directions:</strong></div>
            <div> Click once to mark a square as solved and again to mark it as invalid. A third click will reset the
                square
            </div>
            <a class="block text-blue-600 hover:underline" href="https://en.wikipedia.org/wiki/Nonogram">Nonograms on
                Wikipedia</a>
        </div>
    </div>
</template>

<script>
    import Nonogram from './components/Nonogram.vue'

    export default {
        name: 'App',
        data() {
            return {
                cols: [2, 4, 4, 8, '1 1', '1 1', '1 1 2', '1 1 4', '1 1 4', 8],
                rows: [4, '3 1', '1 3', '4 1', '1 1', '1 3', '3 4', '4 4', '4 2', 2]
            }
        },
        components: {
            Nonogram
        }
    }
</script>

<style>
    #app {
        height: 100vh;
        display: flex;
        align-items: center;

    }
</style>
